import React from 'react';
import { Quote, Award, ShieldCheck, Activity, Lock, HeartHandshake, Scale } from 'lucide-react';
import { Section } from '../ui/Section';
const testimonials = [{
  quote: 'CT Group helped the firm return to work in a secure cloud environment within days and remained available throughout the urgent transition.',
  name: 'Miranda Stephens',
  role: 'Practice Manager, Bowen Buchbinder Vilensky',
  initials: 'MS'
}, {
  quote: 'CT Group’s thorough, professional approach enabled the agreed solution to be implemented with minimal disruption.',
  name: 'Jocelyn Dosser',
  role: 'Practice Manager, Williams & Hughes',
  initials: 'JD'
}];
const pillars = [{
  icon: Award,
  title: 'Expertise',
  body: 'Deep technical knowledge combined with a real understanding of how professional firms work.'
}, {
  icon: ShieldCheck,
  title: 'Ownership and Accountability',
  body: 'We own the environment and the outcome, with clear responsibilities and fewer opportunities for finger-pointing.'
}, {
  icon: Activity,
  title: 'Proactive Reliability',
  body: 'We work to identify issues early and create ‘low-noise’ technology that supports the firm.'
}, {
  icon: Lock,
  title: 'Security as Trust',
  body: 'Security protects client confidence, continuity and commercial risk. It is not a bolt-on.'
}, {
  icon: HeartHandshake,
  title: 'Genuine Care',
  body: 'Every interaction should leave clients feeling heard, supported and confident.'
}, {
  icon: Scale,
  title: 'Honest Value',
  body: 'Clear services, a clear scope and an honest fee — because cheap IT often becomes expensive IT.'
}];
export function Testimonials() {
  return <Section className="bg-white" ariaLabel="Testimonials and brand pillars" data-id="element-469">
      <h2 className="max-w-2xl font-display text-[28px] font-black leading-[1.1] tracking-tight text-navy md:text-[40px]" data-id="element-470">
        What practice managers valued when it mattered.
      </h2>

      <div className="mt-10 grid grid-cols-1 items-stretch gap-6 md:grid-cols-2" data-id="element-471">
        {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-panel border border-border bg-surface-2 p-8 shadow-sm" data-id="element-472">
            <Quote className="h-8 w-8 text-ct-cyan/30" aria-hidden data-id="element-473" />
            <blockquote className="mt-3 text-[18px] font-medium leading-relaxed text-ink" data-id="element-474">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-475">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy font-display text-[15px] font-bold text-white" data-id="element-476">
                {t.initials}
              </span>
              <div data-id="element-477">
                <p className="font-display text-[15px] font-bold text-navy" data-id="element-478">
                  {t.name}
                </p>
                <p className="text-[13px] text-slate" data-id="element-479">{t.role}</p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-slate/60" data-id="element-480">
                  From a published CT Group case study
                </p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      {/* pillars */}
      <div className="mt-16 border-t border-border pt-14" data-id="element-481">
        <p className="text-[13px] font-semibold uppercase tracking-[0.12em] text-slate" data-id="element-482">
          What we stand for
        </p>
        <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-panel border border-border bg-border sm:grid-cols-2 lg:grid-cols-3" data-id="element-483">
          {pillars.map((p, i) => <div key={p.title} className="group flex flex-col bg-white p-7 transition-colors duration-300 hover:bg-surface-2" data-id="element-484">
              <div className="flex items-center justify-between" data-id="element-485">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ct-cyan/10 ring-1 ring-ct-cyan/15" data-id="element-486">
                  <p.icon className="h-5 w-5 text-ct-deep" aria-hidden data-id="element-487" />
                </span>
                <span className="font-display text-[15px] font-black tabular-nums text-slate/25" data-id="element-488">
                  0{i + 1}
                </span>
              </div>
              <h3 className="mt-5 font-display text-[17px] font-bold text-navy" data-id="element-489">
                {p.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-slate" data-id="element-490">
                {p.body}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}